import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import kaufvertrag from '../../docs/Immobilien-Kaufvertrag.pdf';
import schenkungsvertrag from '../../docs/Schenkungsvertrag.pdf';
import gruendung from '../../docs/GmbH-Gruendung.pdf';
import vollmacht from '../../docs/Generalvollmacht.pdf';
import Heading from '../common/Heading';

const Forms = () => {
  return (
    <div className='forms' id='forms'>
      <Heading heading='Formulare' subHeading='Zur schnellen Bearbeitung Ihres Anliegens' />

      <Container>
        <Row>
          <Col xs={12}>
            <p className='text'>
              Die Formulare können Sie bequem am Bildschirm ausfüllen und per E-Mail an uns senden oder ausdrucken, ggf.
              von Hand ausfüllen und per Fax oder Post an uns schicken. Wir melden uns dann bei Ihnen. Bitte sprechen
              Sie uns jederzeit an, wenn wir Ihnen Hilfestellungen geben können.
            </p>
            <p className='small fst-italic text-muted'>
              Zur vollständigen Nutzung der Formularfunktionen muss auf Ihrem Endgerät der Adobe Acrobat Reader
              installiert sein. Sie können diesen bei Bedarf auf der Website von{' '}
              <a href='https://www.adobe.com/de/acrobat/pdf-reader.html' target='_blank' rel='noreferrer noopener'>
                Adobe Acrobat
              </a>{' '}
              kostenfrei herunterladen.
            </p>
          </Col>
        </Row>

        <Tab.Container id='list-group-tabs-example' defaultActiveKey='link1'>
          <Row>
            <Col md={8} lg={6}>
              <ListGroup>
                <ListGroup.Item action eventKey='link1'>
                  Vorbereitung von Immobilien-Kaufverträgen
                </ListGroup.Item>
                <ListGroup.Item action eventKey='link2'>
                  Vorbereitung von Immobilien-Schenkungsverträgen
                </ListGroup.Item>
                <ListGroup.Item action eventKey='link3'>
                  Vorbereitung der Gründung einer GmbH oder UG (haftungsbeschränkt)
                </ListGroup.Item>
                <ListGroup.Item action eventKey='link4'>
                  Vorbereitung einer General- und Vorsorgevollmacht
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col md={4} lg={6}>
              <Tab.Content>
                <Tab.Pane eventKey='link1'>
                  <p className='text'>
                    Die durch dieses Formular erhobenen Daten benötigen wir für die Vorbereitung eines Urkundenentwurfs.
                    Einfach ausfüllen und an uns schicken.
                  </p>
                  <Button href={kaufvertrag} variant='primary' target='_blank'>
                    Herunterladen (PDF)
                  </Button>
                </Tab.Pane>
                <Tab.Pane eventKey='link2'>
                  <p className='text'>
                    Die durch dieses Formular erhobenen Daten benötigen wir für die Vorbereitung des Entwurfs eines
                    Schenkungsvertrags. Einfach ausfüllen und an uns schicken.
                  </p>
                  <Button href={schenkungsvertrag} variant='primary' target='_blank'>
                    Herunterladen (PDF)
                  </Button>
                </Tab.Pane>
                <Tab.Pane eventKey='link3'>
                  <p className='text'>
                    Diese Angaben werden bei der Gründung einer Gesellschaft mit beschränkter Haftung oder einer
                    Unternehmergesellschaft benötigt. Einfach ausfüllen und an uns schicken.
                  </p>
                  <Button href={gruendung} variant='primary' target='_blank'>
                    Herunterladen (PDF)
                  </Button>
                </Tab.Pane>
                <Tab.Pane eventKey='link4'>
                  <p className='text'>
                    Die durch dieses Formular erhobenen Daten werden zur Entwurfsfertigung einer General- und
                    Vorsorgevollmacht benötigt. Einfach ausfüllen und an uns schicken.
                  </p>
                  <Button href={vollmacht} variant='primary' target='_blank'>
                    Herunterladen (PDF)
                  </Button>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </div>
  );
};

export default Forms;
